import { render, staticRenderFns } from "./MainAward.vue?vue&type=template&id=27f95e5c"
import script from "./MainAward.vue?vue&type=script&lang=js"
export * from "./MainAward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports